const SystemConfigCall = async () => {
    let response;
    const { dataService } = await import('../services/data.services');
    const { store } = await import('../redux/store');
    const { handleSystemConfig } = await import('../redux/systemConfigSlice');
    
    response = await dataService.GetAPI(`system-configuration/`);
    if (response?.data?.status === 200) {
        store.dispatch(handleSystemConfig(response?.data?.data));
    }
};

export default SystemConfigCall;